import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgTiming = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M12.644 1.86c-6.074 0-11 4.925-11 11 0 6.074 4.926 11 11 11 6.075 0 11-4.926 11-11 0-6.075-4.925-11-11-11Zm0 20.133A9.135 9.135 0 0 1 3.51 12.86a9.135 9.135 0 0 1 9.134-9.134 9.135 9.135 0 0 1 9.134 9.134 9.135 9.135 0 0 1-9.134 9.134Zm4.29-6.025-3.501-2.532V7.36a.197.197 0 0 0-.197-.196h-1.18a.197.197 0 0 0-.197.196v6.762c0 .064.03.123.08.16l4.062 2.961a.198.198 0 0 0 .275-.042l.702-.957a.196.196 0 0 0-.044-.275Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgTiming)
const Memo = memo(ForwardRef)
export default Memo
